import { render } from "./LabelButton.vue?vue&type=template&id=85430ad2&scoped=true&ts=true"
import script from "./LabelButton.vue?vue&type=script&lang=ts"
export * from "./LabelButton.vue?vue&type=script&lang=ts"

import "./LabelButton.vue?vue&type=style&index=0&id=85430ad2&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/rontend-vue_version_release-euau/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-85430ad2"]])

export default __exports__